<template>
    <div>
  
    <!-- SIDE BAR SECTION -->
        <div class="fixed z-50">
        <sideBar/>
        </div>


        <nav class="sticky w-full z-40 top-0 " >

            <navBar/>

        </nav>
  
      <!-- DASHBOARD -->
  
        <div class="bg-[#e8e6fe] w-full h-screen font-euclid">

            <div class=" mx-10 ml-72 font-euclid">
                
                <div>
                    <div class=" flex items-center w-5/6 mb-6">

                        <h1 class=" w-1/6 mt-8 text-black font-semibold text-base mr-52">Password Settings</h1>

                        <div
                        v-if="success"
                        class=" border w-4/6 mx-auto bg-medalertBlue bg-opacity-10  text-black px-4 py-3 mt-4 rounded relative"
                        role="alert">

                            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
                            <span class="">{{ success }}</span>
                        </div>

                        <div
                        v-if="err"
                        class=" border w-4/6  mx-auto bg-red  text-white px-4 py-3 mt-4 rounded relative"
                        role="alert">

                            <!-- <strong class="font-bold mx-2">Thank you!</strong> -->
                            <span class="">{{ err }}</span>
                        </div>

                    </div>

                    <div class="bg-white w-5/6 px-8 py-8 my-6 mb-4 rounded-md text-left">
                            <div>

                                <div>
                                    <h1 class=" text-gray-500 font-medium text-sm text-left mr-52">CHANGE PASSWORD</h1>
                                </div>
                                <form @submit.prevent="handleChangePassword" action="">
                                    <div class="flex items-center mt-8">
                                        <div class="text-left w-64">
                                            <h1>Current Password</h1>
                                        </div>

                                        <div class="flex flex-col w-2/3 ">
                                            <div class="cursor-pointer text-xs font-semibold font-euclid flex justify-end mb-2">
                                                <span  @click="showCurrentPassword = !showCurrentPassword">  <p v-if="showCurrentPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                                            </div>
                                            <div class="text-left rounded-md border-2">
                                                <input 
                                                v-bind:type="[showCurrentPassword ? 'text' : 'password']" 
                                                v-model="currentPassword" required  class="font-medium text-black w-full p-3">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex items-center mt-8">
                                        
                                            <div class="text-left w-64">
                                                <h1>New Password</h1>
                                            </div>

                                            <div class="flex flex-col w-2/3 ">  

                                                <div class="cursor-pointer text-xs font-semibold font-euclid flex justify-end mb-2">
                                                <span  @click="showPassword = !showPassword">  <p v-if="showPassword"> HIDE </p> <p v-else>SHOW</p> </span>
                                                </div>

                                                <div class="  text-left rounded-md border-2 flex flex-col">
                                                    <input
                                                    v-bind:type="[showPassword ? 'text' : 'password']" 
                                                    v-model="newPassword" required type="password" class="font-medium text-black w-full p-3">
                                                </div>
                                                
                                            </div>  
                                    </div>

                                    <div class="mt-20 flex justify-start mb-5">
                                        <button 
                                        :class="inactive ? 'cursor-not-allowed' : ''"
                                        :disabled="inactive"  class="py-3 px-4 bg-medalertBlue disabled:bg-gray-200 text-white rounded-md hover:bg-blueHover hover:text-white ">
                                            Save Changes
                                        </button>
                                    </div>
                                </form>  


   
                            </div>
                    </div>
                </div>

            </div>

        </div>
  
    </div>
  </template>
  
  <script>
  
  import navBar from '../components/NavBar'
  import sideBar from '../components/SideBar'
  import axios from 'axios';
  
  import { ref } from 'vue'
  import {useRouter} from 'vue-router'
  import { useStore } from "vuex";
  
export default {
  
      components:{navBar, sideBar},

      setup(){

        const store = useStore();
        const router = useRouter();
        

        const success = ref('');
        const err = ref('');
        const inactive = ref(false);
        const currentPassword = ref('');
        const newPassword = ref('');

        const showPassword = ref(false);
        const showCurrentPassword = ref(false);


        const handleChangePassword = async () => {
           try{ 
                inactive.value = true
                const response = await axios.put(`/api/v1/account/change-password?old-password=${currentPassword.value}&new-password=${newPassword.value}`)
                
                if (response){
                    success.value = response.data.result.message + ' Login Now';

                    (currentPassword.value = "",
                    newPassword.value = "")

                    setTimeout(() => {
                    success.value = "";
                    inactive.value = false;
                    router.push("/login");
                    }, 3000);  

                    store.commit("setUser", null);
                    store.commit("saveToken", null);
                    window.localStorage.user = JSON.stringify(null);
                    window.localStorage.token = JSON.stringify(null);
                    location.reload();
                 }
            } 
           catch(error){
            console.log(error)
            err.value =  error.response.data.result.message
            setTimeout(() => {
            err.value = "";
            inactive.value = false
            }, 2000);
           }
        }

        return{
            currentPassword,
            newPassword,
            success,
            err,
            inactive,
            showPassword,
            showCurrentPassword,
            handleChangePassword
        }

        

      }

      
  
}
  
  </script>
  
  <style>
  
  </style>